"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CellDisplayList_1 = __importDefault(require("@Components/ViewWork/Table/ValidationCells/CellDisplayList"));
const contexts_1 = require("@App/contexts");
const usePublisherService_1 = __importDefault(require("@App/services/usePublisherService"));
const tooltip_text_1 = require("@Const/tooltip-text");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const permission_1 = require("@App/helpers/permission");
const table_cell_sanitizer_1 = require("@App/helpers/table-cell-sanitizer");
const add_publisher_table_cells_1 = require("@App/helpers/work-entities/utils/add-publisher-table-cells");
const AddPublishersTableInfo = () => {
    const { workStore, publisherStepStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal) {
        return [];
    }
    const originPublishers = workDraftFromLocal.originalPublishers;
    const publisherService = (0, usePublisherService_1.default)();
    const keyPrefix = (model) => { var _a, _b; return `${model.publisherName}-${model.localId}-${(_a = model.ipiNumber) !== null && _a !== void 0 ? _a : ''}-${(_b = model.ipId) !== null && _b !== void 0 ? _b : ''}`; };
    const adminTableRows = (rows) => rows.map(({ originalPublisherIndex, administratorIndex, publisherModel, adminModel }, index) => {
        var _a;
        return ({
            removeCellIdentifier: `${originalPublisherIndex.toString()}-${administratorIndex.toString()}`,
            removable: (0, permission_1.canAmend)(adminModel.amend),
            cells: (0, add_publisher_table_cells_1.generateAdminTableCells)({
                admin: adminModel,
                index: index,
                publisher: publisherModel,
                getKeyPrefix: (publisher) => keyPrefix(publisher),
            }),
            subTables: [
                {
                    headerRow: {
                        row: [
                            { text: 'Publisher Name' },
                            { text: 'Publisher IPI' },
                            { text: 'Publisher Number' },
                            {
                                text: 'Represented Writers',
                                tooltip: (react_1.default.createElement(CustomToolTip_1.default, { inverse: true, type: '?', place: 'top', info: tooltip_text_1.TOOLTIP_TEXT.createWork.representedWriter })),
                            },
                        ],
                    },
                    rows: [
                        {
                            removeCellIdentifier: (_a = publisherModel.ipId) !== null && _a !== void 0 ? _a : '',
                            removable: (0, permission_1.canAmend)(adminModel.amend),
                            cells: [
                                (0, table_cell_sanitizer_1.tableCellSanitizer)(publisherModel.publisherName),
                                (0, table_cell_sanitizer_1.tableCellSanitizer)(publisherModel.ipiNumber),
                                (0, table_cell_sanitizer_1.tableCellSanitizer)(publisherModel.hfaPublisherNumber),
                                react_1.default.createElement(CellDisplayList_1.default, { readOnly: !(0, permission_1.canAmend)(adminModel.amend), key: `${keyPrefix(publisherModel)}-display-list`, items: publisherModel.writers, onAddToListClicked: () => {
                                        publisherStepStore.initAddWriterToOriginalPublisher(publisherModel);
                                    }, onRemoveFromListClicked: (writerModel) => {
                                        publisherService.removeLinkedWriter(publisherModel, writerModel);
                                    } }),
                            ],
                        },
                    ],
                },
            ],
        });
    });
    const admins = [];
    const nonAdminsPubs = [];
    originPublishers.forEach((model, index) => {
        var _a;
        const hasAdmin = model.administratorPublishers.length > 0;
        if (hasAdmin) {
            model.administratorPublishers.forEach((admin, adminIndex) => {
                admins.push({
                    originalPublisherIndex: index,
                    administratorIndex: adminIndex,
                    publisherModel: model,
                    adminModel: admin,
                });
            });
        }
        else {
            nonAdminsPubs.push({
                removeCellIdentifier: (_a = index.toString()) !== null && _a !== void 0 ? _a : '',
                removable: (0, permission_1.canAmend)(model.amend),
                cells: (0, add_publisher_table_cells_1.generatePublisherTableCells)({
                    publisher: model,
                    index: index,
                    getKeyPrefix: (publisher) => keyPrefix(publisher),
                }),
            });
        }
    });
    const adminRows = adminTableRows(admins);
    return [
        {
            headerRow: {
                row: [
                    {
                        text: 'Administrator',
                        tooltip: (react_1.default.createElement(CustomToolTip_1.default, { inverse: true, place: 'top', type: '?', info: tooltip_text_1.TOOLTIP_TEXT.createWork.administrator })),
                    },
                    { text: 'Administrator IPI' },
                    { text: 'Administrator Number' },
                    { text: 'Collection Share' },
                ],
                removableCells: true,
            },
            rows: [...adminRows],
        },
        {
            headerRow: {
                row: [
                    { text: 'Publisher Name' },
                    { text: 'Publisher IPI' },
                    { text: 'Publisher Number' },
                    { text: 'Collection Share' },
                    { text: 'Add Administrator' },
                    {
                        text: 'Represented Writers',
                        tooltip: (react_1.default.createElement(CustomToolTip_1.default, { inverse: true, place: 'top', type: '?', info: tooltip_text_1.TOOLTIP_TEXT.createWork.representedWriter })),
                    },
                ],
                removableCells: true,
            },
            rows: nonAdminsPubs,
        },
    ];
};
exports.default = AddPublishersTableInfo;
